export class GoogleAnalyticsEvents {
  public static usageEvent({ name, category = 'usage' }: { name: string; category?: string }) {
    return {
      event: `usage_${name}`,
      category,
    };
  }
}
